import { gql } from '@apollo/client';

export const GET_COHORT = gql`
  query GetCohort($id: ID!) {
    cohort: getCohort(id: $id) {
      id
      createdAt
      updatedAt

      description
      name

      # computed
      beneficiariesCount
      institutionsCount
      peopleCount

      institutions {
        id
        name
      }
      intervention {
        id
        name
      }
      people {
        id
        firstName
        lastName
      }
      ownerOrganisation {
        id
        funder {
          id
          name
        }
        institution {
          id
          name
        }
        serviceProvider {
          id
          name
        }
      }
      status
    }
  }
`;
